import { createVanIconComponent } from "./van"

const TodoListOutlined = createVanIconComponent("todo-list-o")
export default TodoListOutlined
